export const MAX_VALUE_CENTS = 9_999_999_999_999;

const brlFormatter = new Intl.NumberFormat("pt-BR", {
	style: "currency",
	currency: "BRL",
});

const BRL_AMOUNT = /^(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?$/;

export function formatBRL(cents: number): string {
	return brlFormatter.format(cents / 100).replace(/\s/g, " ");
}

export function parseBRL(input: string): number | null {
	const normalized = input.replace(/R\$/g, "").replace(/\s/g, "");
	const match = BRL_AMOUNT.exec(normalized);
	if (!match?.[1]) return null;
	const reais = Number(match[1].replaceAll(".", ""));
	const centavos = Number((match[2] ?? "").padEnd(2, "0"));
	const cents = reais * 100 + centavos;
	return Number.isSafeInteger(cents) ? cents : null;
}
